/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_TitleInputs */

const en_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const ko_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의`)
};

const ja_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_title = /** @type {((inputs?: Contact_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_title(inputs)
	if (locale === "ko") return ko_contact_title(inputs)
	return ja_contact_title(inputs)
});